import { SxProps, Theme } from "@mui/material";

/** Hide total/remaining columns on viewports below md (mobile and tablet). */
export const PRODUCT_ITEM_QUANTITY_COLUMN_SX: SxProps<Theme> = {
  display: { xs: "none", md: "table-cell" }
};
